// extracted by mini-css-extract-plugin
export default {"crumb":"Breadcrumbs_crumb__DgGiy","link":"Breadcrumbs_link__QGITZ","current":"Breadcrumbs_current__cMKdZ","icon":"Breadcrumbs_icon__fYxtM"};